module.exports = __webpack_public_path__ + "img/PlusGrey.718fcec2.svg";